<template>
  <base-page-layout title="Aplicativo">
    <v-layout class="my-3 btn-nova">
      <v-spacer />
      <mf-button icon="add" label="Nova campanha" @click="redirect()" />
    </v-layout>

    <v-container fluid class="px-0 pt-0" grid-list-sm>
      <v-row>
        <v-col v-for="(card, index) in cards" :key="index">
          <cbm-card :title="card.text" :number-text="card.value" :boolean-loader="card.loading" :tooltip="card.helpText" />
        </v-col>
      </v-row>
    </v-container>
    <campaigns-table v-if="isFranchisee" mode="push" logsTag="CAMPAIGNS" :franchisee="true" class="mb-3" :items-filter="filterList[0]">
      <template v-slot:title> Campanhas da rede </template>
    </campaigns-table>
    <campaigns-table mode="push" logsTag="CAMPAIGNS" :items-filter="filterList[1]">
      <template v-slot:title> Minhas campanhas </template>
    </campaigns-table>
  </base-page-layout>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'
import CampaignsTable from '@/modules/campanhas/views/components/index/CampaignsTable.vue'
import CbmCard from '@/components/CbmCard.vue'
import { QUERY_GET_CAMPAIGNS_COUNTS_PER_STATUS } from '../../graphql'
import { getStatusLabel, localeString } from '@/config/helpers.js'

export default {
  components: {
    BasePageLayout,
    CampaignsTable,
    CbmCard,
  },
  data: () => ({
    filterList: [
      [
        { label: getStatusLabel('ACTIVE').text, value: 'ACTIVE', color: getStatusLabel('ACTIVE').color, active: true },
        { label: getStatusLabel('SCHEDULED').text, value: 'SCHEDULED', color: getStatusLabel('SCHEDULED').color, active: true },
        { label: getStatusLabel('FINISHED').text, value: 'FINISHED', color: getStatusLabel('FINISHED').color, active: true },
      ],
      [
        { label: getStatusLabel('ACTIVE').text, value: 'ACTIVE', color: getStatusLabel('ACTIVE').color, active: true },
        { label: getStatusLabel('SCHEDULED').text, value: 'SCHEDULED', color: getStatusLabel('SCHEDULED').color, active: true },
        { label: getStatusLabel('DRAFT').text, value: 'DRAFT', color: getStatusLabel('DRAFT').color, active: true },
        { label: getStatusLabel('FINISHED').text, value: 'FINISHED', color: getStatusLabel('FINISHED').color, active: true },
      ],
    ],
  }),
  computed: {
    cards() {
      return [
        {
          value: localeString(this.scheduledSendings?.ACTIVE),
          text: 'Campanhas ativas',
          isInteger: true,
          loading: this.$apollo.queries.scheduledSendings.loading,
        },
        {
          value: localeString(this.scheduledSendings?.SCHEDULED),
          text: 'Envios agendados',
          isInteger: true,
          helpText: this.isFranchisee ? 'Envios que foram programados por você. Disparos da rede não são contabilizados.' : null,
          loading: this.$apollo.queries.scheduledSendings.loading,
        },
      ]
    },
    isFranchise() {
      // rede
      if (!this.$getLoggedUser().is_franchise) return false
      return this.$getLoggedUser().is_franchise
    },
    isFranchisee() {
      // franquia
      if (!this.$getLoggedUser().is_franchisee) return false
      return this.$getLoggedUser().is_franchisee
    },
  },
  apollo: {
    scheduledSendings: {
      query: QUERY_GET_CAMPAIGNS_COUNTS_PER_STATUS,
      update({ campaignsCountsPerStatus }) {
        return campaignsCountsPerStatus
      },
    },
  },
  methods: {
    redirect() {
      this.$router.push('/campanhas/aplicativo/nova').catch(() => {})
    },
  },
}
</script>

<style lang="scss" scoped>
.btn-nova {
  margin-top: -54px !important;
}
</style>
